import React, { Component } from 'react'
import { Container, Row, Col } from 'reactstrap';
import '../App.css';

export default class Home extends Component {
  render() {
    return (
      <Container>
        <Row>
          
          <Col className="col-12 text-center">
            <h1><img src="/images/admin_portal.jpg"></img></h1>
          </Col>
     
        </Row>
    
      </Container>
    )
  }
}
